<template>
	<div class = "pay-money-div">
		<van-row type="flex" justify="space-between">
		  <van-col span="14">
			  <div class = "pay-money-detail">
				  <span>合计：¥</span>
				  <span>{{parseFloat(orderPrice+'').toFixed(2)}}</span>
			  </div>
		  </van-col>
		  <van-col span="10">
			  <div class = "pay-btn">
				  <van-button round :color="this.$enum.CONSTANT.APP_THEME_COLOR" @click="openPayType()">确认支付</van-button>
			  </div>
		  </van-col>
		</van-row>
	</div>
</template>

<script>
	import {Col, Row,Button} from 'vant';
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'PayMoney',
		computed: mapGetters(["getPrice","orderPrice",'getGoodsList']),
		components: {
		      [Col.name]: Col,
		      [Row.name]: Row,
		      [Button.name]: Button,
		      
		 },
		data(){
			return {
			}
		},
		methods:{
			openPayType(){
				// console.log(this.getGoodsList);
				this.$emit('openPayType');
			},
		}
	}
</script>

<style scoped>
	.pay-money-div {
		padding: 15px;
		width: 100%;
		height: auto;
		position: fixed;
		bottom: 0px;
		left: 0px;
		border-top: 0;
		background-color: #ffffff;
		box-shadow: 0 2px 10px #c5c5c5;
		border-top-color: #c5c5c5;
	}
	.pay-money-detail>span:first-child {
		font-size: 15px;
		font-weight: 550;
		color: #2d2d2d;
	}
	
	.pay-money-detail>span:last-child {
		font-size: 22px;
		font-weight: 550;
		color: #2d2d2d;
	}
	
	.pay-btn {
		text-align: right;
	}
	
	.pay-btn .van-button{
		width: auto;
		height: auto;
		padding: 6px 10px;
		margin: 0;
		font-size: 15px;
	}
</style>
